import { Sparkles, LayoutTemplate, MapPinned, FileText, Palette, Info } from "lucide-react";
import { getFieldExplanation } from "./aiExplainability";

function SummaryItem({ icon, label, value, explanation, emptyText = "AI will suggest this" }) {
    const finalValue = value && String(value).trim() ? value : emptyText;

    return (
        <div className="sss-item">
            <div className="sss-item-icon">{icon}</div>

            <div className="sss-item-copy">
                <span>{label}</span>
                <strong>{finalValue}</strong>

                {value && String(value).trim() ? (
                    <div className="sss-explainer">
                        <Info size={13} />
                        <em>{explanation}</em>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default function SmartSuggestionsSummaryPanel({ form }) {
    const pages = Array.isArray(form.pages) ? form.pages.filter(Boolean) : [];
    const hasStrategy =
        form.businessModel ||
        form.primaryWebsiteMode ||
        form.primaryEntityType ||
        form.locationFocus ||
        form.contentStyleHint ||
        form.themeKey ||
        form.tone ||
        form.brandStyle ||
        pages.length > 0;

    if (!hasStrategy) return null;

    return (
        <div className="sss-shell">
            <div className="sss-head">
                <div className="sss-badge">
                    <Sparkles size={16} />
                    <span>AI Strategy Summary</span>
                </div>

                <h3 className="sss-title">Here’s what AI understood about your business</h3>

                <p className="sss-subtitle">
                    These suggestions are based on your business details, offerings, and website goal.
                    You can edit any of them below before generating the final website.
                </p>
            </div>

            <div className="sss-grid">
                <SummaryItem
                    icon={<LayoutTemplate size={16} />}
                    label="Business Type"
                    value={form.businessModel}
                    explanation={getFieldExplanation("businessModel", form)}
                />

                <SummaryItem
                    icon={<LayoutTemplate size={16} />}
                    label="Website Focus"
                    value={form.primaryWebsiteMode}
                    explanation={getFieldExplanation("primaryWebsiteMode", form)}
                />

                <SummaryItem
                    icon={<FileText size={16} />}
                    label="Main Content Type"
                    value={form.primaryEntityType}
                    explanation={getFieldExplanation("primaryEntityType", form)}
                />

                <SummaryItem
                    icon={<MapPinned size={16} />}
                    label="Service Coverage"
                    value={form.locationFocus}
                    explanation={getFieldExplanation("locationFocus", form)}
                />

                <SummaryItem
                    icon={<Palette size={16} />}
                    label="Content Direction"
                    value={form.contentStyleHint}
                    explanation={getFieldExplanation("contentStyleHint", form)}
                />

                <SummaryItem
                    icon={<Palette size={16} />}
                    label="Theme Direction"
                    value={[form.themeKey, form.tone, form.brandStyle].filter(Boolean).join(" • ")}
                    explanation={getFieldExplanation("themeKey", form)}
                />
            </div>

            <div className="sss-pages-block">
                <div className="sss-pages-label">Recommended Pages</div>

                <div className="sss-pages-row">
                    {pages.length > 0 ? (
                        pages.map((page) => (
                            <span key={page} className="sss-page-chip">
                                {page}
                            </span>
                        ))
                    ) : (
                        <span className="sss-page-chip sss-page-chip-muted">
                            AI will suggest pages
                        </span>
                    )}
                </div>

                {pages.length > 0 ? (
                    <div className="sss-pages-explainer">
                        <Info size={13} />
                        <em>{getFieldExplanation("pages", form)}</em>
                    </div>
                ) : null}
            </div>
        </div>
    );
}